import Flickity from 'flickity'
import { eventBus } from '@/main'
// import { IconLeftArrow, IconRightArrow } from '@/components/standard/my-icons'
require('waypoints/lib/noframework.waypoints')

export const MySlider = {
  name: 'my-slider',
  template: `
    <div class="o-slider">
      <div class="o-slider__controls">
        <div class="o-slider__btns">
          <button class="o-slider__btn" @click="prevSlide()">
            <svg class="icon icon-left-arrow"><use xlink:href="#icon-left-arrow"></use></svg>
            <span class="u-hide">Previous</span>
          </button>
          <button class="o-slider__btn" @click="nextSlide()">
            <svg class="icon icon-right-arrow"><use xlink:href="#icon-right-arrow"></use></svg>
            <span class="u-hide">Next</span>
          </button>
        </div>
        <ul class="o-slider__dots">
          <li class="o-slider__dot" :class="{'o-slider__dot--active': index === flkty.selectedIndex }" @click="changeSlide(index)" v-for="(item, index) in items"></li>
        </ul>
      </div>
      <div ref="slider" class="o-slider__wrap">
        <slot></slot>
      </div>
    </div>
  `,
  props: {
    defer: {
      type: Boolean,
      default: false
    }
  },
  // components: {
  //   IconLeftArrow,
  //   IconRightArrow
  // },
  data () {
    return {
      flkty: null,
      current: null,
      items: null,
      ready: false
    }
  },
  computed: {
    content () {
      return this.$store.state.content
    },
    parentTitle () {
      return (this.$parent.title !== undefined) ? this.$parent.title : this.$parent.$parent.title
    }
  },
  methods: {
    initSlider () {
      this.flkty = new Flickity(this.$refs.slider, {
        cellSelector: '.o-slider__item',
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        draggable: true,
        adaptiveHeight: true,
        imagesLoaded: true,
        selectedAttraction: 0.025,
        friction: 0.28
      })
      this.$emit('slide-changed', this.flkty.selectedIndex)
      this.items = this.flkty.getCellElements()
      this.flkty.on('select', () => {
        this.$emit('slide-changed', this.flkty.selectedIndex)
        Waypoint.refreshAll()
      })
      this.flkty.on('dragEnd', () => {
        window.gtag('event', 'slide_swiped', { 'event_label': this.parentTitle + ' - Slide: ' + this.flkty.selectedIndex })
        // console.log(this.parentTitle + ' - Slide: ' + this.flkty.selectedIndex)
      })
      window.addEventListener('load', () => {
        this.flkty.resize()
      })
    },
    prevSlide () {
      this.flkty.previous()
      window.gtag('event', 'slide_clicked', { 'event_label': this.parentTitle + ' - Slide: ' + this.flkty.selectedIndex })
      // console.log(this.parentTitle + ' - Slide: ' + this.flkty.selectedIndex)
    },
    nextSlide () {
      this.flkty.next()
      window.gtag('event', 'slide_clicked', { 'event_label': this.parentTitle + ' - Slide: ' + this.flkty.selectedIndex })
      // console.log(this.parentTitle + ' - Slide: ' + (this.flkty.selectedIndex)
    },
    changeSlide (id) {
      this.flkty.selectCell(id)
      window.gtag('event', 'slide_clicked', { 'event_label': this.parentTitle + ' - Slide: ' + this.flkty.selectedIndex })
      // console.log(this.parentTitle + ' - Slide: ' + this.flkty.selectedIndex)
    },
    resizeFlkty () {
      this.$nextTick(() => {
        this.flkty.resize()
      })
    }
  },
  mounted () {
    if (this.content.length !== 0) {
      this.initSlider()
    } else {
      eventBus.$on('content-has-loaded', () => {
        setTimeout(() => {
          this.$nextTick(() => {
            this.initSlider()
          })
        }, 0)
      })
    }
  }
}

export const MySlide = {
  name: 'my-slide',
  template: `
    <div class="o-slider__item o-panel">
      <div class="o-panel__container">
        <slot></slot>
      </div>
    </div>
  `,
  data () {
    return {
      active: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/standard/my-slider.js